const minHeight = typeof window !== 'undefined' && window.innerHeight;

const styles = {
    splitView: {
        display: "flex", flexDirection:"row", alignItems:"flex-stretch"
    },
    treeViewPanel: {
        border: "solid 1px grey"
    },
    divider:{
        width: "1px",
        padding:"0",
        margin:"0",
        border: "1px solid #808080",
        position: "fixed"
    },
    dividerHitbox: {
        cursor: "col-resize",
        display: "flex",
        padding: "0 1rem 0 0",
        width:"0px"
      },
    content: {
        flex: 1
    }
  };
  
  export default styles
  


// WEBPACK FOOTER //
// ./src/components/splitview/styles.js